<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" v-for="(data, $index) in langData" :key="$index" :class="{ active: $index == 0 }">
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a :class="true ? 'tab' + $index : ''" data-toggle="tab" :href="true ? '#tab-' + $index : ''" aria-expanded="true" @click="showTab($event, $index)">{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form :model="memberPrivilegeDetail" ref="memberPrivilegeDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(langItem, index) in memberPrivilegeDetail.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Membership category </label>
                <div class="col-sm-4">
                  <el-select disabled v-model="membershipCategoryId" clearable>
                    <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryCode" :value="item.id"> </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Membership name </label>
                <div class="col-sm-4">
                  <el-select disabled v-model="membershipId" clearable>
                    <el-option v-for="item in membershipList" :key="item.id" :label="item.membershipName" :value="item.id"> </el-option>
                  </el-select>
                </div>
                <div class="col-sm-4" style="padding-top: 11px">
                  {{ remark }}
                </div>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="Privilege" name="1">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Description title </label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'langMap.' + index + '.descriptionTitle'"
                            :rules="{
                              required: true,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input v-model="langItem.descriptionTitle" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Section description</label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'langMap.' + index + '.sectionDescription'"
                            :rules="{
                              required: true,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input type="textarea" v-model="langItem.sectionDescription" show-word-limit :maxlength="500"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <draggable
                        class="sortable-list agile-list"
                        v-model="memberPrivilegeDetail.memberPrivilegeSection"
                        @start="drag = true"
                        @end="drag = false"
                        style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                      >
                        <li class="" v-for="(item, i) in memberPrivilegeDetail.memberPrivilegeSection">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div>Privilege {{ i + 1 }}</div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Privilege title </label>
                              <div class="col-sm-9 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).privilegeTitle }}
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label"> Privilege detail</label>
                              <div class="col-sm-10 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).privilegeDetial }}
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label"> Icon Type</label>
                              <div class="col-sm-10 pad-t-7">
                                {{ item.iconType }}
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(memberPrivilegeDetail.memberPrivilegeSection, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(memberPrivilegeDetail.memberPrivilegeSection, 90, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </draggable>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" v-if="memberPrivilegeDetail.memberPrivilegeSection.length < 50" @click="addGroupEvent(memberPrivilegeDetail.memberPrivilegeSection, 90)">Add</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="Promotion" name="2">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Promotion title</label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'memberPrivilegePromotionLangMap.' + index + '.title'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.memberPrivilegePromotionLangMap, 'title') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input v-model="getObject(memberPrivilegeDetail.memberPrivilegePromotionLangMap, langItem.langCode).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Promotion description </label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'memberPrivilegePromotionLangMap.' + index + '.description'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.memberPrivilegePromotionLangMap, 'description') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input type="textarea" v-model="getObject(memberPrivilegeDetail.memberPrivilegePromotionLangMap, langItem.langCode).description"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> External link </label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'memberPrivilegePromotionLangMap.' + index + '.externalLink'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.memberPrivilegePromotionLangMap, 'externalLink') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input v-model="getObject(memberPrivilegeDetail.memberPrivilegePromotionLangMap, langItem.langCode).externalLink" show-word-limit :maxlength="500"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="FAQ" name="3">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Description title </label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'faqLangMap.' + index + '.descriptionTitle'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.faqLangMap, 'descriptionTitle') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input v-model="getObject(memberPrivilegeDetail.faqLangMap, langItem.langCode).descriptionTitle" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-2 control-label"> Section description</label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'faqLangMap.' + index + '.sectionDescription'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.faqLangMap, 'sectionDescription') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input type="textarea" v-model="getObject(memberPrivilegeDetail.faqLangMap, langItem.langCode).sectionDescription" show-word-limit :maxlength="500"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <draggable
                        class="sortable-list agile-list"
                        v-model="memberPrivilegeDetail.memberPrivilegeFaqSection"
                        @start="drag = true"
                        @end="drag = false"
                        style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                      >
                        <li class="" v-for="(item, i) in memberPrivilegeDetail.memberPrivilegeFaqSection">
                          <div class="row margin-0" style="padding: 0px !important">
                            FAQ {{ i + 1 }}
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Question title </label>
                              <div class="col-sm-10 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).questionTitle }}
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label"> Answer</label>
                              <div class="col-sm-10 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).answer }}
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(memberPrivilegeDetail.memberPrivilegeFaqSection, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(memberPrivilegeDetail.memberPrivilegeFaqSection, 91, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </draggable>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" v-if="memberPrivilegeDetail.memberPrivilegeFaqSection.length < 50" @click="addGroupEvent(memberPrivilegeDetail.memberPrivilegeFaqSection, 91)">
                        Add
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="form-group">
                <el-collapse>
                  <el-collapse-item title="Price" name="4">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Section title </label>
                        <div class="col-sm-10">
                          <el-form-item
                            :prop="'langMap.' + index + '.priceSectionTitle'"
                            :rules="{
                              required: checkMultFile(memberPrivilegeDetail.langMap, 'priceSectionTitle') ? true : false,
                              message: $t('message.required'),
                              trigger: 'blur',
                            }"
                          >
                            <el-input v-model="langItem.priceSectionTitle" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <draggable
                        class="sortable-list agile-list"
                        v-model="memberPrivilegeDetail.memberPrivilegePriceSection"
                        @start="drag = true"
                        @end="drag = false"
                        style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                      >
                        <li class="" v-for="(item, i) in memberPrivilegeDetail.memberPrivilegePriceSection">
                          <div class="row margin-0" style="padding: 0px !important">
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Member Tier </label>
                              <div class="col-sm-10 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).memberTier }}
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-2 control-label">Description (Annual/ Quarter/ Monthly) </label>
                              <div class="col-sm-10 pad-t-7">
                                {{ getObject(item.langMap, langItem.langCode).description }}
                              </div>
                            </div>
                          </div>
                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(memberPrivilegeDetail.memberPrivilegePriceSection, i)"><i class="fa fa-trash-o"></i></a>
                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(memberPrivilegeDetail.memberPrivilegePriceSection, 92, i)"><i class="fa fa-pencil"></i></a>
                        </li>
                      </draggable>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15">
                      <div class="btn btn-primary" v-if="memberPrivilegeDetail.memberPrivilegePriceSection.length < 5" @click="addGroupEvent(memberPrivilegeDetail.memberPrivilegePriceSection, 92)">
                        Add
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="checkPermission('MemberPrivilege save')" @click="checkEvent()">
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
const upload = require("../upload");
import draggable from "vuedraggable";

import axios from "axios";
import VJstree from "vue-jstree";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      memberPrivilegeDetail: {
        "membershipCategoryId": "",
        "membershipId": "",
        "langMap": [
          {
            "langCode": "en_US",
            "descriptionTitle": "",
            "sectionDescription": "",
            "priceSectionTitle": "",
          },
          {
            "langCode": "zh_CN",
            "descriptionTitle": "",
            "sectionDescription": "",
            "priceSectionTitle": "",
          },
          {
            "langCode": "zh_HK",
            "descriptionTitle": "",
            "sectionDescription": "",
            "priceSectionTitle": "",
          },
        ],
        "faqLangMap": [
          {
            "langCode": "en_US",
            "descriptionTitle": "",
            "sectionDescription": "",
          },
          {
            "langCode": "zh_CN",
            "descriptionTitle": "",
            "sectionDescription": "",
          },
          {
            "langCode": "zh_HK",
            "descriptionTitle": "",
            "sectionDescription": "",
          },
        ],
        "memberPrivilegeSection": [],
        "memberPrivilegeFaqSection": [],
        "memberPrivilegePriceSection": [],
        "memberPrivilegePromotionLangMap": [
          {
            "langCode": "en_US",
            "title": "",
            "description": "",
            "externalLink": "",
          },
          {
            "langCode": "zh_CN",
            "title": "",
            "description": "",
            "externalLink": "",
          },
          {
            "langCode": "zh_HK",
            "title": "",
            "description": "",
            "externalLink": "",
          },
        ],
      },
      editor: ClassicEditor,
      membershipCategoryId: "",
      membershipId: "",
      editorConfig: {
        toolbar: ["bold", "italic", "underline"],
      },
      categoryList: [],
      membershipList: [],
      remark: "",
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    memberPrivilegeDetail: {
      handler: function (val, oldval) {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  components: {
    VJstree,
    draggable,
    "file-upload": fileupload,
  },
  created() {
    this.setObj();
    this.init();

    this.getCategory();
    this.getMembership();
    this.membershipCategoryId = parseInt(this.$route.query.membershipCategoryId);
    this.membershipId = parseInt(this.$route.query.id);
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    setObj: function () {},
    goBack() {
      this.$router.push({
        path: "/main/memberPrivilege",
        query: { ...this.$route.query },
      });
    },
    async init() {
      let obj = this.getAuthObj();
      obj.membershipId = this.$route.query.id;
      obj.apiUrl = "/getMemberPrivilegeDetail";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      if (data.data.result) {
        this.$set(this, "memberPrivilegeDetail", data.data.result);
      }
      var that = this;
      setTimeout(function () {
        that.$store.state.edit = false;
      }, 500);
    },
    async getCategory() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/getMembershipCategoryList";
      var data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.$set(this, "categoryList", data.data);
    },
    async getMembership() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.membershipCategoryId = this.$route.query.membershipCategoryId;
      objdata.apiUrl = "/getMembershipList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      data.data.resultList.forEach(element => {
        if (element.langMap.length > 0) element.membershipName = element.langMap[0].membershipName;
      });
      this.membershipList = data.data.resultList;
      this.membershipList.forEach(element => {
        if (element.id == this.membershipId) {
          this.remark = element.remark;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      }
    },
    checkEvent: function () {
      var that = this;
      this.$refs["memberPrivilegeDetail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      delete this.memberPrivilegeDetail.id;
      this.memberPrivilegeDetail.membershipCategoryId = this.membershipCategoryId;
      this.memberPrivilegeDetail.membershipId = this.membershipId;
      obj.memberPrivilege = JSON.stringify(this.memberPrivilegeDetail);
      obj.apiUrl = "/saveMemberPrivilege";
      var data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.state.edit = false;
        if (!this.$route.query.id) {
          this.$router.go(-1);
        }
        this.$toastr.s("Save Success");
      }
    },
    Delete() {
      this.showWarning(1);
    },
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    deleteObj(obj, index) {
      obj.splice(index, 1);
    },

    editObj: function (obj, type, index) {
      this.addGroupEvent(obj, type, index);
    },
    checkMultFile(obj, name) {
      var flag = false;
      for (var i = 0; i < obj.length; i++) {
        if (obj[i][name] != "") {
          flag = true;
          break;
        }
      }
      return flag;
    },
    addGroupEvent: function (obj, objType, index) {
      var that = this;
      if (index != undefined) {
        var data = obj[index];
      } else if (objType == 90) {
        var data = {
          iconType: "",
          langMap: [
            {
              langCode: "en_US",
              privilegeTitle: "",
              privilegeDetial: "",
            },
            {
              langCode: "zh_CN",
              privilegeTitle: "",
              privilegeDetial: "",
            },
            {
              langCode: "zh_HK",
              privilegeTitle: "",
              privilegeDetial: "",
            },
          ],
        };
      } else if (objType == 91) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              questionTitle: "",
              answer: "",
            },
            {
              langCode: "zh_CN",
              questionTitle: "",
              answer: "",
            },
            {
              langCode: "zh_HK",
              questionTitle: "",
              answer: "",
            },
          ],
        };
      } else if (objType == 92) {
        var data = {
          langMap: [
            {
              langCode: "en_US",
              "memberTier": "",
              "description": "",
              "price": "",
              "remarks": "",
            },
            {
              langCode: "zh_CN",
              "memberTier": "",
              "description": "",
              "price": "",
              "remarks": "",
            },
            {
              langCode: "zh_HK",
              "memberTier": "",
              "description": "",
              "price": "",
              "remarks": "",
            },
          ],
        };
      }

      this.$store.commit("setgroup", {
        obj: data,
        objType: objType,
        index: index,
        boolean: true,
        callback: function () {
          that.$store.commit("setgroup", { string: "", boolean: false });
          if (index == undefined) {
            obj.push(data);
          }
        },
      });
    },
  },
};
</script>
